import ApiRequest from "../utils/ApiRequest";

export default class UserTraining {
  commentTrainingAsMentor = async (userTrainingId, comment, score) => {

    return await ApiRequest.set(`/v1/training/comment/${userTrainingId}`, "POST", {
      mentor_comment: comment,
      mentor_score: score
    })
  }

  getUserTrainingAsMentor = async (moduleId) => {
    return await ApiRequest.set(`/v1/training/mentor/${moduleId}/as_learner`, "GET")
  }
}
